import locationController from "./location/location.controller";
import locationTemplate from "./location/location.html";
import travelExpenseTypeController from "./travel-expense-type/travel-expense-type.controller";
import travelExpenseTypeTemplate from "./travel-expense-type/travel-expense.html";
import expenseReceiptController from "./expense-receipt-modal/expense-receipt-modal.controller";
import expenseReceiptTemplate from "./expense-receipt-modal/expense-receipt-modal.html";
import enterActualsController from "./enter-actuals/enter-actuals.controller";
import enterActualsTemplate from "./enter-actuals/enter-actuals.html";
import generalBusinessItemController from "./general-business-item/general-business-item.controller";
import generalBusinessItemTemplate from "./general-business-item/general-business-item.html";
import otherDirectCostsItemController from "./other-direct-costs-item/other-direct-costs-item.controller";
import otherDirectCostsItemTemplate from "./other-direct-costs-item/other-direct-costs-item.html";

export {
  locationController,
  locationTemplate,
  travelExpenseTypeController,
  travelExpenseTypeTemplate,
  expenseReceiptController,
  expenseReceiptTemplate,
  enterActualsController,
  enterActualsTemplate,
  generalBusinessItemController,
  generalBusinessItemTemplate,
  otherDirectCostsItemController,
  otherDirectCostsItemTemplate
}



// WEBPACK FOOTER //
// ./client/pages/expenses/modals/index.js